import React from "react";
import {observer} from "mobx-react";

import "./station-tab-pane.scss";

import {Tab, Table, Header, Icon} from "semantic-ui-react";

import {Kiwis, Station} from "../../../../../kiwis";
import {StationInfoConfiguration} from "../../../../../config/station-info-configuration";
import {FormatUtils} from "../../../../../utils/format-utils";
import {FieldInfoConfiguration} from "../../../../../core/config/field-info-configuration";

interface StationTabPaneProps {
    kiwis: Kiwis;
    station: Station;
    parentWidth: number | string;
    parentHeight: number | string;
    aspectRatio: number; // aspect ratio of parent windows
    isFullScreen: boolean;
    isDocked: boolean;
    active: boolean; // if tab is active,
    config: StationInfoConfiguration;
}

const StationInfoTableRow = (props: any) => (
    <Table.Row className={"geo-station-pane-table-row"} key={`station-table-row-${props.stationId}-${props.name}`}>
        <Table.Cell><Header as="h4" content={props.label}/></Table.Cell>
        <Table.Cell>{props.value} {props.unit}</Table.Cell>
    </Table.Row>
);

@observer
export class StationTabPane extends React.Component<StationTabPaneProps, any> {

    constructor(props: StationTabPaneProps) {
        super(props);
        this.state = {
            updating: false
        };
    }

    /**
     * Convert \n line breaks to <br/> html breaks
     *
     * @param text
     */
    static addLineBreaks(text: string) {
        return text.split("\n").map((txt, index) => (
            <React.Fragment key={`${txt}-${index}`}>
                {txt}
                <br/>
            </React.Fragment>
        )
        );
    }

    componentDidMount() {
    }

    componentWillUnmount() {
        // TODO remove watches
    }

    render() {
        const {config, station, active} = this.props;
        if (!active) {
            return null;
        }

        const {baseId} = station;
        const row = config.row(baseId);
        if (!row) {
            // eslint-disable-next-line no-console
            console.error(`No station info fields configured for this base ID: ${baseId}`);
            return null;
        }
        const rows = row.fields.map((field: FieldInfoConfiguration) => {
            const value = this.formatValue(field, station);

            // only show row with link to external website when url is present
            if (field.urlFieldOptions && !value) {
                return null;
            }

            return <StationInfoTableRow
                key={`station-info-table-row-${station.id}-${field.fieldName}`}
                label={StationTabPane.addLineBreaks(field.label)}
                value={value}
                name={field.fieldName}
                unit={field.unitName}
                stationId={station.id}
            />;
        });

        return (
            <Tab.Pane
                key={`station-pane-${station.id}`}
                className={"station-tab-pane scrollable-content"}
                active={active}
            >
                <Table basic="very" celled collapsing unstackable className={"geo-station-pane-table"}>
                    <Table.Body>
                        {rows}
                    </Table.Body>
                </Table>
            </Tab.Pane>
        );
    }

    /**
     * Formats the field value
     *
     * @param field
     * @param station
     */
    private formatValue(field: FieldInfoConfiguration, station: Station) {

        if (field.format) {
            return FormatUtils.formatValue(station[field.fieldName], field.format);
        } else if (field.urlFieldOptions) {
            if (!field.urlFieldOptions.label) {
                // eslint-disable-next-line no-console
                console.error("urlFieldOptions without label.");
                return;
            }
            if (!station[field.fieldName]) {
                return null;
            }
            return (
                <div className="link-to-external">
                    <a className="link"
                        href={station[field.fieldName]}
                        title={field.urlFieldOptions.label}
                        target="_blank" rel="noreferrer"
                    >
                        {field.urlFieldOptions.label}
                    </a>
                    <Icon name="external alternate"/>
                </div>
            );
        }
        return station[field.fieldName];
    }
}
